import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * CcfSuggestionIcon used to display Suggestion Icon in the app space panel
 * @param props - SvgIconProps
 * @example -
 * ```
 * <CcfSuggestionIcon />
 * ```
 * @returns - SVG of Suggestion Icon
 */
export const CcfSuggestionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0C11.3137 0 14 2.59692 14 5.8004C14 7.47733 13.2546 9.0164 11.7961 10.3943C11.7324 10.4544 11.6831 10.5268 11.6511 10.6065L11.6252 10.6884L10.6891 14.6051C10.5048 15.3763 9.82359 15.935 9.0181 15.9947L8.87476 16H7.12549C6.30654 16 5.58999 15.4839 5.34865 14.7385L5.31107 14.6046L4.37626 10.6885C4.34955 10.5766 4.29016 10.4744 4.20515 10.3942C2.8153 9.08192 2.07265 7.6235 2.00507 6.03902L2 5.8004L2.00321 5.60893C2.1077 2.49408 4.75256 0 8 0ZM9.75034 13.1993H6.24883L6.52069 14.3348C6.57912 14.5798 6.78817 14.7606 7.04008 14.7942L7.12549 14.7999H8.87476C9.13487 14.7999 9.36395 14.6437 9.45465 14.4141L9.47956 14.3349L9.75034 13.1993ZM8 1.20008C5.433 1.20008 3.34074 3.16503 3.24481 5.62394L3.24138 5.8004L3.24694 6.02202C3.30995 7.27276 3.90942 8.43748 5.07251 9.53563C5.2911 9.74205 5.45323 9.99671 5.54556 10.2767L5.58586 10.4187L5.96248 11.9992H10.0367L10.4156 10.4182C10.4843 10.1306 10.6249 9.86462 10.8241 9.643L10.9285 9.53596C12.0909 8.4378 12.6901 7.273 12.7531 6.02206L12.7586 5.8004L12.7551 5.62394C12.6592 3.16503 10.567 1.20008 8 1.20008Z"
          fill="#93A4AA"
        />
      </svg>
    </SvgIcon>
  );
};
